<template>
  <el-card style="width: 20%">未定义模块</el-card>
</template>

<script>
export default {
  name: 'MainUndefined'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MainUndefined.vue